/*eslint-disable react-hooks/exhaustive-deps*/

import React, { useState, useEffect } from "react";
import { Typography, Input, Button, Upload, Loading } from "../core";
import { Form, Avatar } from "antd";
import styled from "styled-components";
import { MixStyle } from "../styles";
import SvgIcon from "../assets/icons/icon";
import { useSelector, useDispatch } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import { creatcompany, clearState } from "../redux/Action/company";

const Notify_Utils = require("../helper/utils/Notification");

const UTILS = require("../helper/utils/upload-image");

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const UploadBtn = styled(Button)`
  border-radius: 50%;
  .anticon-spin {
    color: #3d5166;
    width: 40px;
    height: 40px;
  }
`;

const Section = styled.section`
  label {
    ${MixStyle.Label}
  }
`;
const CreateCompanyForm = (props) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loginUserId, setLoginUserId] = useState("");
  const [upload, setUpload] = useState({
    loading: false,
  });
  const [isLoading, setIsLoading] = useState(false);

  let user = useSelector((state) => state.auth.userDetail);
  let comapnyReduxState = useSelector((state) => state.comapny);

  useEffect(() => {
    if (comapnyReduxState.addCompanySuccess) {
      setIsLoading(false);
      form.resetFields();
      props.closeModal("addCompanyModal");
      Notify_Utils.openNotificationWithIcon(
        "success",
        comapnyReduxState.addCompanySuccess
      );
      // setCompanies(comapnyReduxState.companies);
      dispatch(clearState());
      props.getCompanies();
    }
    if (comapnyReduxState.addCompanyFail) {
      setIsLoading(false);
      Notify_Utils.openNotificationWithIcon(
        "error",
        comapnyReduxState.addCompanyFail
      );
      dispatch(clearState());
    }
  }, [comapnyReduxState]);
  useEffect(() => {
    setLoginUserId(user._id || "");
  }, [user]);

  const onFinish = (values) => {
    const payload = {
      ...values,
      userId: user?._id || loginUserId,
      companyLogo: upload.imageUrl || "",
    };
    setIsLoading(true);
    dispatch(creatcompany(payload));
  };

  const onFinishFailed = () => {};

  const handleChange = (info) => {
    if (info.file.status === "uploading") {
      setUpload({ loading: true });
      return;
    }
    if (info.file.status === "done") {
      UTILS.getBase64(info.file.originFileObj, (imageUrl) =>
        setUpload({
          imageUrl,
          loading: false,
        })
      );
    }
  };

  const customUpload = ({ file, onSuccess }) => {
    setUpload({ loading: true });
    UTILS.getBase64(file, (imageUrl) => {
      setUpload({ imageUrl, loading: false });
      onSuccess("ok");
    });
  };

  const uploadButton = (
    <UploadBtn width="100px" height="100px" bg="white">
      {upload.loading ? (
        <LoadingOutlined />
      ) : (
        <SvgIcon width={52.18} height={41} color="#3D5166" icon="uploadIcon" />
      )}
    </UploadBtn>
  );

  const { imageUrl } = upload;

  return (
    <Section>
      <div>{isLoading ? <Loading /> : ""}</div>

      <Form
        form={form}
        {...layout}
        name="basic"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          label="Company Name"
          name="companyName"
          rules={[
            {
              required: true,
              message: "Please input Company Name!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Company Email"
          name="companyEmail"
          rules={[
            {
              required: true,
              message: "Please input Company Email!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="NTN"
          name="NTN"
          rules={[
            {
              required: true,
              message: "Please input NTN!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="STRN"
          name="STRN"
          rules={[
            {
              required: true,
              message: "Please input STRN!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Phone Number"
          name="phoneNumber"
          rules={[
            {
              required: true,
              message: "Please input Phone Number!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Company Address"
          name="companyAddress"
          rules={[
            {
              required: true,
              message: "Please input Address!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="company_logo"
          rules={[
            {
              required: false,
              message: "Please Select Company Logo",
            },
          ]}
          valuePropName="fileList"
          getValueFromEvent={UTILS.normFile}
        >
          <Upload
            name="avatar"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            customRequest={customUpload}
            onChange={handleChange}
          >
            {imageUrl ? (
              <Avatar size={120} src={upload.imageUrl} />
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>

        <Form.Item>
          <Button width="187px" bg="#404E67" type="primary" htmlType="submit">
            <Typography
              text="Create Company"
              as="h5"
              noMargin
              weight="bold"
              align="center"
              color="white"
            />
          </Button>
        </Form.Item>
      </Form>
    </Section>
  );
};
export default CreateCompanyForm;
